import colors from 'globals/colors'
import measures from 'globals/measures'
import styled from 'styled-components'


interface SeparatorProps {
  hideOnMobile?: boolean,
  color?: string
}

export const Separator = styled.div<SeparatorProps>`
  width:35px;
  height: 2px;
  background-color: ${(props) => props.color || colors.waterBlue};
  margin-top: 8px;
  margin-bottom: 38px;
  
  @media(max-width: ${measures.mobileThreshold}px) {
    ${(props) => props.hideOnMobile && `
      display: none;
    `};
  }
`

interface AuthTitleWrapperProps {
  small?: boolean
}

export const AuthTitleWrapper = styled.div<AuthTitleWrapperProps>`
  & > h2 {
    font-family: 'Publico Roman';
    line-height: 36px;
    font-size: 26px;
    padding: 8px 0;
    margin-bottom: 0;
    
    ${(props) => props.small && `
      line-height: 19px;
      font-size: 16px;
      font-weight: bold;
    `}
  }
  
  ${(props) => props.small && `
    & ${Separator} {
      margin-top: 8px;
      margin-bottom: 20px;
    }
  `};
`

export const AuthSubtitle = styled.h3`
  line-height: 28px;
  font-size: 16px;
  margin-bottom: 0;
  color: ${colors.waterBlue};
`
